
import React from 'react';
import { MaturityScoreResult } from '@/types/assessment';
import MaturityScoreCard from '../MaturityScoreCard';

interface MaturityScoreSectionProps {
  currentMaturity: MaturityScoreResult;
  targetMaturity: MaturityScoreResult;
}

const MaturityScoreSection: React.FC<MaturityScoreSectionProps> = ({ 
  currentMaturity, 
  targetMaturity 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <MaturityScoreCard 
        title="Current Maturity" 
        maturityResult={currentMaturity}
      />
      
      <MaturityScoreCard 
        title="Target Maturity" 
        maturityResult={targetMaturity}
      />
    </div>
  );
};

export default MaturityScoreSection;
